import { createDefaultTyrann } from '@apis/common';
import { invoiceQueryParam } from '@models/Invoice';
import { invoice } from '@models/Invoice2';
import * as t from 'io-ts';

export const invoiceApis = createDefaultTyrann({
  '/invoice/': {
    get: {
      query: invoiceQueryParam,
      response: {
        200: t.type({
          count: t.number,
          results: t.array(invoice),
        }),
        400: t.type({
          message: t.string,
        }),
      },
    },
  },
});
